<template lang="pug">
  .b2b-page-profile
    transition(name="fade" mode="out-in")
      router-view
</template>

<script>

export default {
  name: 'b2b-page-profile'
}
</script>

<style lang="scss" scoped>

</style>
